import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfTopAppCategoryAppsApplicationService } from '../../../core/application/services/app-category-metrics/get-self-top-app-category-apps.application-service';
import { SelfTopAppCategoryAppsAggregateRoot } from '../../../core/domain/aggregates/app-category-metrics/self-top-app-category-apps.aggregate-root';
import { GetSelfTopAppCategoryAppsRequestDto } from '../../dtos/app-category-metrics/get-self-top-app-category-apps.request.dto';

export class GetSelfTopAppCategoryAppsQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfTopAppCategoryAppsApplicationService
  ) {}

  async execute(
    props: GetSelfTopAppCategoryAppsRequestDto
  ): Promise<SelfTopAppCategoryAppsAggregateRoot[]> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new Error(
        `GetSelfTopAppCategoryAppsQuery.execute encountered an error ${error}`
      );
    }
  }
}
